<div class="container">
  <div mat-dialog-content>
    <form class="example-form" #f="ngForm">
      <mat-label class="email"><strong>Email:</strong>{{userEmail}}</mat-label>
      <mat-label class ="phone" ><strong>Phone:</strong></mat-label>
      <mat-form-field class="example-full-width">
        <span matPrefix>+ &nbsp;</span>
        <input
          [(ngModel)]="tnumber"
          name="phoneNumber"
          matInput
          #number = ngModel
          maxlength="15"
          minlength="7"
          (input)="checkNumber($event)"
          [pattern]="getPhoneRegex()"
          autocomplete="off"
          placeholder="Country Code + Telephone">
        <mat-hint align="start"><strong>Ex: +44 1233225114</strong> </mat-hint>
        <mat-error *ngIf="number?.errors && (number.dirty || number.touched)">
          <div *ngIf="number?.invalid">
            Phone number is invalid.
          </div>
        </mat-error>
      </mat-form-field>
    </form>
  </div>
</div>
